import { getGradeLabel } from '@car-pool/shared/schoolRecords';

function isActive(value) {
  return value === true || value === 1 || String(value) === '1';
}

function normalizeGradeCode(value) {
  if (value === null || value === undefined || value === '') return null;
  const gradeCode = Number(value);
  return Number.isInteger(gradeCode) ? gradeCode : null;
}

export function buildSchoolGradeOptions(gradeNames = [], students = []) {
  const optionsByCode = new Map();
  const inactiveGradeCodes = new Set();

  gradeNames.forEach((grade) => {
    const gradeCode = normalizeGradeCode(grade?.grade_code);
    if (gradeCode === null) return;

    if (!isActive(grade.is_active)) {
      inactiveGradeCodes.add(gradeCode);
      optionsByCode.delete(gradeCode);
      return;
    }

    optionsByCode.set(gradeCode, {
      ...grade,
      grade_code: gradeCode,
      label: grade.label || getGradeLabel(gradeCode),
      is_active: 1,
    });
  });

  students.forEach((student) => {
    const gradeCode = normalizeGradeCode(student?.grade);
    if (gradeCode === null || inactiveGradeCodes.has(gradeCode) || optionsByCode.has(gradeCode)) return;

    optionsByCode.set(gradeCode, {
      grade_code: gradeCode,
      label: getGradeLabel(gradeCode),
      is_active: 1,
      derived_from_students: true,
    });
  });

  return [...optionsByCode.values()]
    .sort((left, right) => Number(left.grade_code) - Number(right.grade_code));
}
